module.exports = __webpack_public_path__ + "static/service-hero-f801cec7eb3958f67cc30405fe3962d2.png";